import produce from 'immer';
import { isEmpty } from 'lodash';
import {
    ACTIONS, setLoadingStatus, setErrorStatus, saveSearchResult, addToBasket, loadBasket, removeFromBasket,
} from 'travel-connect/store/actions';

const initialState = {
    basket: {},
    searchResult: {},
    status: {
        error: null,
        loading: false,
    },
};

export default (st, action) =>
{
    const state = isEmpty(st) ? initialState : st;

    return produce(state, (draft) =>
    {
        switch (action.type)
        {
            case ACTIONS.TRAVEL_SEARCH_SAVE_SEARCH_RESULT: {
                const searchResultStatus = saveSearchResult(action.payload, action.key);
                draft.searchResult[action.key] = searchResultStatus.payload;
                break;
            }
            case ACTIONS.STATUS_SET_LOADING_STATUS: {
                const loadingStatus = setLoadingStatus(action.payload);
                draft.status.loading = loadingStatus.payload;
                break;
            }
            case ACTIONS.STATUS_SET_ERROR_STATUS: {
                const errorStatus = setErrorStatus(action.payload);
                draft.status.error = errorStatus.payload;
                break;
            }
            case ACTIONS.BASKET_ADD_TO_BASKET: {
                const addedTobasket = addToBasket(action.payload);
                draft.basket = {
                    ...draft.basket,
                    ...addedTobasket.payload,
                };
                break;
            }
            case ACTIONS.BASKET_LOAD_BASKET: {
                const basketLoaded = loadBasket(action.payload);
                draft.basket = {
                    ...draft.basket,
                    ...basketLoaded.payload,
                };
                break;
            }
            case ACTIONS.BASKET_REMOVE_FROM_BASKET: {
                const removedFrombasket = removeFromBasket(action.payload);
                draft.basket = {
                    ...draft.basket,
                    ...removedFrombasket.payload,
                };
                break;
            }
            default:
                break;
        }
    });
};
